const doc = [({"zh_tw":({"adminConstantUserStatus":({"created":"已創建", "registered":"掛號的"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;